import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import { NavLink, Outlet } from "react-router-dom";
import new_arrival_img1 from "../assets/images/dummy/new_arrival_img1.jpeg";
import new_arrival_sm_img1 from "../assets/images/dummy/new_arrival_sm_img1.jpeg";
import new_arrival_sm_img2 from "../assets/images/dummy/new_arrival_sm_img2.jpeg";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function AuthLayout() {
  return (
    <>
      <section className="authLayout_container">
        <Container fluid className="container">
          <Row className="align-items-center">
            <Col sm="6">
              <div className="auth_container">
                <div className="w-100">
                  <Outlet />
                </div>
              </div>
            </Col>
            <Col sm="6">
              <div className="auth_sldr_container">
                <OwlCarousel
                  items={1}
                  margin={8}
                  autoplay={true}
                  dots={true}
                  nav={false}
                >
                  <div className="auth_sldr_item">
                    <img loading="lazy"  src={new_arrival_img1} alt="bag1" />
                    <div className="caption">
                      <h4 className="fs-26">
                        ACCESSORIES TALLIS & TEFILLEN BATEL
                      </h4>
                      <p className="fs-16">
                        Plastic Protector Black Leather Look Back for Talis and
                        Tefilin Batel + Handle
                      </p>
                    </div>
                  </div>
                  <div className="auth_sldr_item">
                    <img loading="lazy"  src={new_arrival_sm_img1} alt="bag1" />
                    <div className="caption">
                      <h4 className="fs-26">Waterproof Tefillin Batel</h4>
                      <p className="fs-16">
                        Waterproof, with handle and pocket inside.
                      </p>
                    </div>
                  </div>
                  <div className="auth_sldr_item">
                    <img loading="lazy"  src={new_arrival_sm_img2} alt="bag1" />
                    <div className="caption">
                      <h4 className="fs-26">
                        ACCESSORIES TALLIS & TEFILLEN BATEL
                      </h4>
                      <p className="fs-16">
                        Plastic Protector Black Leather Look Back for Talis and
                        Tefilin Batel + Handle
                      </p>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default AuthLayout;
